import React, { memo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import MemberAvatar from '../MemberAvatar';
import './style.scss';

const ModalApprove = ({
  isOpen,
  toggle,
  member = null,
  onAccept = null,
  onReject = null,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const displayName = member?.uName || member?.name || 'Member';

  const handleAccept = useCallback(async () => {
    if (!onAccept || submitting) return;
    setSubmitting(true);
    try {
      await onAccept(member, () => {
        toggle?.();
      });
    } catch (error) {
    } finally {
      setSubmitting(false);
    }
  }, [onAccept, member, submitting, toggle]);

  const handleReject = useCallback(async () => {
    if (!onReject || submitting) return;
    setSubmitting(true);
    try {
      await onReject(member, () => {
        toggle?.();
      });
    } catch (error) {
      // Error is already toasted by action hook
    } finally {
      setSubmitting(false);
    }
  }, [onReject, member, submitting, toggle]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      className="modal-approve-wrapper"
    >
      <div className="modal-hd">
        <span className="modal-title">Membership Request</span>
        <button type="button" className="modal-close" onClick={toggle}>
          ×
        </button>
      </div>

      <div className="member-hero">
        <MemberAvatar
          member={member}
          name={displayName}
          className="member-hero-avatar"
        />

        <div className="member-hero-name">{displayName}</div>
        <div className="member-hero-contact">
          {[member?.phone, member?.email].filter(Boolean).join(' · ')}
        </div>
      </div>

      <div className="modal-section">
        <div className="modal-section-title">Verification Response</div>
        <div className="verification-response">
          {member?.answer ? (
            <div className="response-text">{member.answer}</div>
          ) : (
            <div className="empty-response">No verification response submitted</div>
          )}
        </div>
      </div>

      <div className="modal-footer">
        <button
          type="button"
          className="modal-btn-reject"
          onClick={handleReject}
          disabled={submitting}
        >
          {submitting ? 'Processing...' : 'Reject'}
        </button>
        <button
          type="button"
          className="modal-btn-accept"
          onClick={handleAccept}
          disabled={submitting}
        >
          {submitting ? 'Processing...' : 'Accept'}
        </button>
      </div>
    </Modal>
  );
};

ModalApprove.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  member: PropTypes.shape({
    answer: PropTypes.string,
    email: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    phone: PropTypes.string,
    photoUrl: PropTypes.string,
    uName: PropTypes.string,
    uid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onAccept: PropTypes.func,
  onReject: PropTypes.func,
};

export default memo(ModalApprove);
